import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarHistoryCdpBanner from "./component";
import { updateShowCarHistoryFlowInitModal } from "../car-history-report/actions";

const mapStateToProps = (
    {
        carHistoryReport: {
            showCarHistoryFlowInitModal
        }
    }
) => ({
    showCarHistoryFlowInitModal
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateShowCarHistoryFlowInitModalConnect: updateShowCarHistoryFlowInitModal
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarHistoryCdpBanner);
